import Cart from "@screens/cart"
import React from "react"

export default () => <Cart lang="nl-nl" />
